import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-value-footer',
  templateUrl: './value-footer.component.html'
})
export class ValueFooterComponent implements OnInit {
  @Input() showContinue: Boolean;
  @Input() enableContinue: Boolean = false;
  @Input() showBack: Boolean = false;
  @Input() enableBack: Boolean;
  @Input() isCalculatedOpportunityValue = false;
  @Input() totalOpportunityValue: number;
  @Input() enableSubmitCase = false;
  @Input() furtherRedirectionButtonToShow: string;
  @Output() buttonContinueEmit = new EventEmitter();
  @Output() buttonBackEmit = new EventEmitter();
  @Output() buttonSubmitCaseEmit = new EventEmitter();
  @Output() buttonRejectCaseEmit = new EventEmitter();
  @Output() buttonApproveCaseEmit = new EventEmitter();
  @Output() buttonTerminateCaseEmit = new EventEmitter();
  @Input() isMechChemical = false;

  checkValue: string;

  constructor() { }

  ngOnInit() {
  }

  continueSelected($event) {
    this.buttonContinueEmit.emit({});
  }

  backSelected() {
    this.buttonBackEmit.emit({});
  }

  submitCaseSelected() {
    this.buttonSubmitCaseEmit.emit({});
  }

  rejectCaseSelected() {
    this.buttonRejectCaseEmit.emit({});
  }

  approveCaseSelected() {
    this.buttonApproveCaseEmit.emit({});
  }

  terminateCaseSelected() {
    this.buttonTerminateCaseEmit.emit({});
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/shared/components/value-footer/value-footer.component.ts